<div class='wrapMatOption wrapMatOption--{{isTextCenter?"textCenter":""}}' (click)='clickEmit.emit()'>
  <error *ngIf='textError' [text]='textError'></error>
  <span *ngIf='text' class='wrapMatOption__text'>{{text}}</span>
</div>
